/** List of the pointer-like events. */
const pointerEvents = [`mouseup`, `mousemove`, `mousedown`, `touchstart`, `touchmove`, `touchend`];

export default pointerEvents;
